/* HILO · Process steps — curtain reveal (styles: assets/hilo-steps-reveal.css)
   Marks each [data-hh-steps] list .hsr-ready, then gives every .hh-step
   .is-in the first time it scrolls into view. Steps already on screen when
   the page opens are shown straight away (no flash, no wait); their dashed
   link still draws. Does nothing for reduced motion or very old browsers,
   so the steps are simply visible. Re-runs when the theme editor reloads
   the section, and shows a step at once when it is selected there. */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || !('IntersectionObserver' in window)) return;
  function each(list, fn) { Array.prototype.forEach.call(list, fn); }

  function init(scope) {
    each((scope || document).querySelectorAll('[data-hh-steps]'), function (list) {
      if (list.hsrReady) return;
      list.hsrReady = true;
      var items = list.querySelectorAll('.hh-step');
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          e.target.classList.add('is-in');
          io.unobserve(e.target);
        });
      }, { rootMargin: '0px 0px -12% 0px', threshold: 0.15 });

      each(items, function (step) {
        var r = step.getBoundingClientRect();
        if (r.top < vh * 0.88 && r.bottom > 0) step.classList.add('is-in', 'hsr-instant');
        else io.observe(step);
      });
      list.classList.add('hsr-ready');
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          each(list.querySelectorAll('.hsr-instant'), function (s) { s.classList.remove('hsr-instant'); });
        });
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var step = e.target && e.target.closest ? e.target.closest('.hh-step') : null;
    if (step) step.classList.add('is-in');
  });
})();
